import { Link } from "react-router-dom";

const processSteps = [
  {
    icon: "ri-discuss-line",
    title: "Étude & Diagnostic",
    desc: "Analyse de votre ouvrage, diagnostic de l'état d'étanchéité existant et conseil personnalisé pour définir la meilleure solution technique adaptée à vos contraintes.",
  },
  {
    icon: "ri-draft-line",
    title: "Mémoire technique & Devis",
    desc: "Rédaction d'un mémoire technique détaillé exposant toutes les dispositions prévues, accompagné d'un devis transparent et d'un planning précis des travaux.",
  },
  {
    icon: "ri-tools-line",
    title: "Réalisation des travaux",
    desc: "Exécution des travaux d'étanchéité par nos équipes qualifiées, avec des matériaux adaptés aux contraintes climatiques et à la nature de chaque ouvrage.",
  },
  {
    icon: "ri-checkbox-circle-line",
    title: "Livraison & Garantie",
    desc: "Réception du chantier avec vous, contrôle d'étanchéité, levée des réserves et garantie décennale sur l'ensemble de nos ouvrages d'étanchéité.",
  },
];

const services = [
  {
    icon: "ri-building-2-line",
    title: "Membranes bitumineuses",
    desc: "Pose de membranes bitumineuses soudées à la flamme ou auto-adhésives, adaptées aux toitures-terrasses, parkings et ouvrages d'art.",
    color: "bg-[#e6f7ed]",
    href: "/services/toitures-terrasses",
  },
  {
    icon: "ri-drop-line",
    title: "Étanchéité liquide",
    desc: "Application de résines et membranes liquides polyuréthane ou époxy pour une étanchéité sans joint, idéale pour les formes complexes.",
    color: "bg-[#f0faf4]",
    href: "/notre-approche",
  },
  {
    icon: "ri-shield-check-line",
    title: "Géomembranes & EPDM",
    desc: "Pose de géomembranes synthétiques EPDM ou PVC pour bassins, réservoirs, piscines et toitures végétalisées.",
    color: "bg-[#e6f7ed]",
    href: "/notre-approche",
  },
  {
    icon: "ri-home-gear-line",
    title: "Isolation thermique",
    desc: "Complexes d'étanchéité avec isolation thermique intégrée (sarking, toiture inversée) pour optimiser les performances énergétiques.",
    color: "bg-[#f0faf4]",
    href: "/services/etancheite-isolation",
  },
  {
    icon: "ri-road-map-line",
    title: "Étanchéité des fondations",
    desc: "Protection des sous-sols, fondations et murs enterrés contre les infiltrations d'eau et les remontées capillaires.",
    color: "bg-[#e6f7ed]",
    href: "/notre-approche",
  },
  {
    icon: "ri-refresh-line",
    title: "Réfection & Rénovation",
    desc: "Diagnostic et réfection complète des systèmes d'étanchéité défaillants, avec ou sans dépose de l'existant selon l'état de l'ouvrage.",
    color: "bg-[#f0faf4]",
    href: "/notre-approche",
  },
];

export default function CEESection() {
  return (
    <>
      {/* Process Section */}
      <section id="realisations" className="py-12 md:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="flex flex-col lg:flex-row gap-8 md:gap-16 items-start">
            {/* Left */}
            <div className="w-full lg:w-5/12">
              <span className="text-xs font-bold uppercase tracking-widest text-[#00a340] mb-2 block">Notre méthode de travail</span>
              <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-3 leading-tight" style={{ fontFamily: "'Montserrat', sans-serif" }}>
                Un processus <span className="text-[#00a340]">rigoureux et maîtrisé</span>
              </h2>
              <div className="w-12 h-1 bg-[#00a340] rounded-full mb-4"></div>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-4 text-justify">
                Chez KS BTP, chaque chantier d&apos;étanchéité est géré avec méthode et rigueur. Le présent mémoire technique expose dans le détail toutes les dispositions que compte prendre KS BTP pour la réalisation de vos travaux.
              </p>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed mb-5 text-justify">
                Nos chefs de chantier expérimentés assurent un suivi quotidien des travaux, une coordination optimale et une communication transparente avec nos clients, du diagnostic jusqu&apos;à la livraison finale.
              </p>
              <div className="flex items-center gap-3 p-4 rounded-xl bg-[#e6f7ed] border border-[#a8f0c0]">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-[#00a340] text-white flex-shrink-0">
                  <i className="ri-award-line text-lg"></i>
                </div>
                <div>
                  <div className="font-bold text-gray-800 text-sm">Spécialiste en étanchéité</div>
                  <div className="text-xs text-gray-500">Garantie décennale sur tous nos ouvrages</div>
                </div>
              </div>
              <div className="mt-5">
                <Link
                  to="/notre-approche"
                  className="inline-flex items-center gap-2 px-5 py-2.5 rounded-md bg-[#00a340] text-white text-sm font-bold whitespace-nowrap hover:bg-[#007a30] transition-colors cursor-pointer"
                >
                  Découvrir notre approche
                  <i className="ri-arrow-right-line"></i>
                </Link>
              </div>
            </div>

            {/* Right: Steps */}
            <div className="w-full lg:w-7/12 grid grid-cols-1 sm:grid-cols-2 gap-4">
              {processSteps.map((step, i) => (
                <div key={step.title} className="flex gap-4 p-4 md:p-5 rounded-xl border border-gray-100 bg-[#fafafa] hover:border-[#a8f0c0] transition-colors">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-[#e6f7ed] text-[#00a340] flex-shrink-0">
                    <i className={`${step.icon} text-xl`}></i>
                  </div>
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      <span className="text-xs font-bold text-[#00a340]">0{i + 1}</span>
                      <span className="font-bold text-gray-800 text-sm">{step.title}</span>
                    </div>
                    <p className="text-gray-500 text-xs leading-relaxed">{step.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-12 md:py-24 bg-[#f5fdf8]">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-8 md:mb-14">
            <h2 className="text-2xl md:text-4xl font-extrabold text-gray-900 mb-3" style={{ fontFamily: "'Montserrat', sans-serif" }}>
              Nos techniques d&apos;étanchéité
            </h2>
            <p className="text-gray-500 text-sm md:text-base max-w-xl mx-auto">
              Des solutions d&apos;étanchéité adaptées à chaque type d&apos;ouvrage et aux contraintes climatiques de votre région
            </p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
            {services.map((s) => (
              <Link
                key={s.title}
                to={s.href}
                className="p-5 md:p-6 rounded-xl bg-white border border-gray-100 hover:border-[#a8f0c0] transition-all group cursor-pointer block"
              >
                <div className={`w-12 h-12 flex items-center justify-center rounded-xl ${s.color} text-[#00a340] mb-3 group-hover:bg-[#00a340] group-hover:text-white transition-colors`}>
                  <i className={`${s.icon} text-2xl`}></i>
                </div>
                <h3 className="font-bold text-gray-800 text-sm md:text-base mb-2">{s.title}</h3>
                <p className="text-gray-500 text-xs md:text-sm leading-relaxed text-justify">{s.desc}</p>
                <span className="inline-flex items-center gap-1 mt-3 text-[#00a340] text-xs font-semibold group-hover:gap-2 transition-all">
                  En savoir plus <i className="ri-arrow-right-line"></i>
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
